import { combineReducers } from 'redux'
import UIReducer from './UIReducer'
import TableReducer from './TableReducer'
import StateReducer from '../../../Shared/Redux/Reducers/StateReducer'
import FormReducer from '../../../Shared/Redux/Reducers/FormReducer'
import AuthReducer from '../../../Shared/Redux/Reducers/AuthReducer'
const rootReducer = combineReducers({ UIReducer, TableReducer, StateReducer, FormReducer, AuthReducer });

export default rootReducer;